import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iProteinListState{
    response : any;
    isLoading : boolean;
    message : string;   
}

const initialState:iProteinListState = {
    response : [],
    isLoading : false,
    message : ""
}

export const getProteinListAPI = createAsyncThunk(
    "GET_PROTEIN_LIST",
    async(_,{rejectWithValue}) => {
        try{
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/data/ppi-inhibitor/protein-name-list/';
            
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`,
            {
                withCredentials: true,
            })
            return response.data;
        }catch(error){

            return rejectWithValue(error.response ? error.response.data : error.message)
        }
    }
)


export const ProteinListSlice = createSlice({
    name: "dataTableList",
    initialState,
    reducers: {},
    extraReducers: (builder) =>{
        builder
        .addCase(getProteinListAPI.pending,(state)=>{
            state.isLoading = true
            state.message = ""
        })
        .addCase(getProteinListAPI.fulfilled,(state, action)=>{
            state.response = action.payload
            state.isLoading = false
        })
        .addCase(getProteinListAPI.rejected,(state)=>{
            state.isLoading = false
            state.message = "error"

        })

    }
})

export default ProteinListSlice.reducer;